import { Box, Button, Grid } from "@mui/material";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomDateTime from "../CustomComponents/CustomDateTime";
import { useEffect, useState } from "react";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import axios from "axios";
import CustomDateField from "../CustomComponents/CustomDateField";

const BatchReport = () => {
  const [gridRows, setGridRows] = useState([]);
  const [gridVisibility, setGridVisibility] = useState(true);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const goButtonHandler = async () => {
    const response = await axios.post("/batch/getBatchStatusByDate", {
      startDateTime: startDate === null ? startDate : new Date(startDate),
      endDateTime: endDate === null ? endDate : new Date(endDate),
    });
    const dataWithKey = response.data.map((record) => {
      return {
        ...record,
        id: record.jobInstanceId,
        startTime: new Date(record.startTime).toLocaleString(),
        endTime: new Date(record.endTime).toLocaleString(),
      };
    });
    setGridRows(dataWithKey);
  };
  const getGridData = async () => {
    const response = await axios.get("/batch/getAllBatchStatus");
    const dataWithKey = response.data.map((record) => {
      return {
        ...record,
        id: record.jobInstanceId,
        startTime: new Date(record.startTime).toLocaleString(),
        endTime: new Date(record.endTime).toLocaleString(),
      };
    });
    setGridRows(dataWithKey);
  };
  const columnsData = [
    {
      field: "jobInstanceId",
      headerAlign: "center",
      headerName: "Job ID",
      flex: 150,
    },
    {
      field: "batchId",
      headerAlign: "center",
      headerName: "Batch ID",
      flex: 150,
    },
    {
      field: "batchName",
      headerAlign: "center",
      headerName: "Batch Name",
      flex: 150,
    },
    {
      field: "batchDescription",
      headerAlign: "center",
      headerName: "Batch Description",
      flex: 150,
    },
    {
      field: "startTime",
      headerAlign: "center",
      headerName: "Start Time",
      flex: 200,
    },
    {
      field: "endTime",
      headerAlign: "center",
      headerName: "End Time",
      flex: 200,
    },
    {
      field: "status",
      headerAlign: "center",
      headerName: "Status",
      flex: 150,
    },
  ];
  const ClearButtonHandler = () => {
    setStartDate(null);
    setEndDate(null);
  };
  useEffect(() => {
    getGridData();
  }, []);
  return (
    <>
      <AccordianContainer
        title="Batch Report"
        initialOpen={true}
        sx={{ margin: "8px !important" }}
      >
        <Box sx={{ marginTop: "-1%" }}>
          <Grid container rowSpacing={0} columnSpacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
              <CustomDateField
                label="Start Date"
                variant="standard"
                value={startDate}
                onChange={(value) => {
                  setStartDate(value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
              <CustomDateField
                label="End Date"
                variant="standard"
                value={endDate}
                onChange={(value) => {
                  setEndDate(value);
                }}
              />
            </Grid>
          </Grid>
          <Box
            sx={{
              marginTop: "8px",
              marginBottom: "4px",
              display: "flex",
              gap: "8px",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              type="submit"
              sx={{ height: "2rem" }}
              onClick={goButtonHandler}
            >
              GO
            </Button>
            <Button
              sx={{
                color: "white",
                backgroundColor: "black",
                height: "2rem",
                fontWeight: "bold",
              }}
              onMouseOver={({ target }) => {
                target.style.backgroundColor = "black";
                target.style.color = "white";
              }}
              variant="contained"
              onClick={ClearButtonHandler}
            >
              Clear
            </Button>
          </Box>
        </Box>
      </AccordianContainer>
      {gridVisibility && (
        <Box
          sx={{
            color: "red",
            background: "white",
            padding: "0.8rem",
            borderRadius: "0.4rem",
          }}
        >
          <CustomDataGrid
            noDataMessage="No Data."
            noDataOnFilterMessage="No Data on Applied Filter."
            rows={gridRows}
            columns={columnsData}
            rowHeight={40}
            pageSize={10}
            pageSizeOptions={[10]}
            gridLazyLoad={() => {}}
            onSortModelChange={() => {}}
          />
        </Box>
      )}
    </>
  );
};
export default BatchReport;
